export default {
	state: {
		shops: [
			{
				id: '001',
				street: 'пр-кт Ермака, дом 44',
				point: 'МАГНИТ'
			},
			{
				id: '002',
				street: 'ул. Мацоты С.В. ул, дом 58',
				point: 'МАГНИТ'
			},
			{
				id: '003',
				street: 'пр-кт Платовский, дом 71',
				point: 'МАГНИТ'
			},
			{
				id: '004',
				street: 'ул. Ященко А.А. 1А',
				point: 'О`КЕЙ'
			},
			{
				id: '005',
				street: 'пр-кт Платовский, дом 59А',
				point: 'ПЕРЕКРЕСТОК'
			},
			{
				id: '006',
				street: 'пер.Магнитный, д. 1 литер А',
				point: 'Развитие малых форматов'
			},
			{
				id: '007',
				street: 'ул. Московская 34',
				point: 'ТАВРОВСКИЕ МЯСНЫЕ ЛАВКИ'
			}
		]
	},
	mutations: {},
	actions: {},

	getters: {
		getNovocherkask (state) {
			return state.shops
		}
	}
}